export default "__VITE_ASSET__B1bG8hO3__"